import { Dispatch, SetStateAction } from "react";

/**
 * @summary Parse a label for Reference and Lookup elements
 * @description Collections can return stringified arrays, if we get one then we want to grab whatever is in index 0 and display that
 */
export const parseLabel = (label?: string) => {
	if (label === undefined) return;
	try {
		const lb = JSON.parse(label);
		if (Array.isArray(lb)) {
			return lb[0];
		}
		// numbers, objects, null - just return the string
		return label;
	} catch (err) {
		// If it's not JSON parsable return the string
		return label;
	}
};

export const extractOnApplyParameters = (props: {
	isApplyClicked?: boolean;
	fieldsIsEditedStatus?: {
		[key: string]: boolean;
	};
	setFieldsIsEditedStatus?: Dispatch<
		SetStateAction<{
			[key: string]: boolean;
		}>
	>;
}) => {
	const isOnApplyPropsProvided =
		props.isApplyClicked !== undefined &&
		props.fieldsIsEditedStatus !== undefined &&
		props.setFieldsIsEditedStatus !== undefined;
	const requiredOnApplyProps = {
		isApplyClicked: props.isApplyClicked as boolean,
		fieldsIsEditedStatus: props.fieldsIsEditedStatus as {
			[key: string]: boolean;
		},

		setFieldsIsEditedStatus:
			props.setFieldsIsEditedStatus as React.Dispatch<
				React.SetStateAction<{
					[key: string]: boolean;
				}>
			>,
	};
	return { isOnApplyPropsProvided, requiredOnApplyProps };
};
